import React from 'react';
import { Progress } from 'semantic-ui-react';
import { HeaderConatiner } from './style';

interface IStepHeaderProps {
  headerLogo: string;
  stepNumber: string | number;
  totalSteps: string | number;
  heading: string;
  subHeading: string;
  extraWording?: string | number;
}

const StepHeader = (props: IStepHeaderProps): React.ReactElement => {
  return (
    <HeaderConatiner>
      <div className="headerImageContainer">
        <div>
          <img src={props?.headerLogo} alt="logo" />
        </div>

        <span className="stepNumber">{`Step ${props?.stepNumber} ${
          props?.extraWording || ''
        }`}</span>
        <Progress value={props?.stepNumber} total={props?.totalSteps} size="tiny" />
      </div>
      <div className="headerTextContainer">
        <h1 className="headingText">{props?.heading}</h1>
        <span className="headingDescription">{props?.subHeading}</span>
      </div>
    </HeaderConatiner>
  );
};

export default StepHeader;
